import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { KatSpinner } from "@amzn/katal-react";

import App from "./containers/App/App";

import "@amzn/katal-components/styles.css";

// The Suspense component causes React to display the fallback KatSpinner until
// the i18n translation strings have been loaded.

ReactDOM.render(
  <React.StrictMode>
      <React.Suspense fallback={<KatSpinner size="large" />}>
        <Router>
          <App/>
        </Router>
      </React.Suspense>
  </React.StrictMode>,
  document.getElementById("root")
);
